import { Upload } from 'antd';

Upload.__hasLoad = true;

export default Upload;
